/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

import "./CVEDetail.css";

import React from "react";

import { bindActionCreators, Dispatch } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import { CVEsState as RCVEListState, slice } from "store/company/cves.slice";

import VAccordion from "components/ThreeKey/VAccordion";

import KASCTree from "./KASCTree/KASCTree";
import CVSSData from "./CVSSData/CVSSData";
import CVERefs from "./CVERefs/CVERefs";

import Widget from "components/ThreeKey/Widget";
import { CVEDDetailProps, CVEDetailState } from "./CVEDetail.types";
import { DateTime } from "lib/DateTime";


class CVEDetail extends React.Component<CVEDDetailProps, CVEDetailState> {

   public render(): React.ReactNode {

      let ret = <></>;
      let cveWidgetCaption: React.ReactNode = "CVE Detail";

      if (this.props.cves.selectedCve) {

         /** Description */

         const descHeader =
            <>
               <span>Description</span>
               <span className="assigner" title="Assigner" >{this.props.cves.selectedCve.cve.CVE_data_meta.ASSIGNER}</span>
            </>

         let description = "";
         for (const descData of this.props.cves.selectedCve.cve.description.description_data) {
            if (descData.lang === "en") description += descData.value + " ";
         }
         description = description.trim();

         /** CVSS */

         const cvss3 = this.props.cves.selectedCve.impact.baseMetricV3 ?

               <div className="score">
                  CVSS 3.0: <strong>{this.props.cves.selectedCve.impact.baseMetricV3.cvssV3.baseScore}&nbsp;&nbsp;&nbsp;{this.props.cves.selectedCve.impact.baseMetricV3.cvssV3.baseSeverity}</strong>
               </div>
            :
               <div>CVSS 3.0: <strong>N/A</strong></div>;

         const cvss2 = this.props.cves.selectedCve.impact.baseMetricV2 ?

               <div className="score">
                  CVSS 2.0: <strong>{this.props.cves.selectedCve.impact.baseMetricV2.impactScore}&nbsp;&nbsp;&nbsp;{this.props.cves.selectedCve.impact.baseMetricV2.severity}</strong>
               </div>
            :
               <div>CVSS 2.0: <strong>N/A</strong></div>;


         const cvssHeader =

            <div className="cvss-header">
               {cvss3}
               {cvss2}
            </div>

         const refsHeader = <div>References</div>;

         const kascHeadere = <div>Known affected software configurations</div>;

         const lastModifiedDate: string = DateTime.toYYYYMMDDHHMM(new Date(this.props.cves.selectedCve.publishedDate).getTime());
         const publishedDate: string = DateTime.toYYYYMMDDHHMM(new Date(this.props.cves.selectedCve.lastModifiedDate).getTime());

         ret = (
            <div className="cve-detail">

               <VAccordion componentName="description" header={descHeader}>
                  <div style={{textAlign: "left"}}>
                     {description}
                  </div>
               </VAccordion>

               <VAccordion header={cvssHeader}>
                  <CVSSData impactData={this.props.cves.selectedCve.impact} />
               </VAccordion>

               <VAccordion header={refsHeader}>
                  <CVERefs refsData={this.props.cves.selectedCve.cve.references.reference_data} />
               </VAccordion>

               <VAccordion header={kascHeadere}>
                  <KASCTree data={this.props.cves.selectedCveAffectedConfigs} isLoading={this.props.cves.cveAffectedConfigsLoading} />
               </VAccordion>

            </div>
         )

         cveWidgetCaption =
            <>
               <span>{this.props.cves.selectedCve.cve.CVE_data_meta.ID}</span>
               <span className="lastPublishedDate" dangerouslySetInnerHTML={{ __html: `
                  <span title="Published date: ${publishedDate}\nLast modified date: ${lastModifiedDate}"}>
                     <span class="dateIcon"></span>
                     <span class="date">${lastModifiedDate}</span>
                  </span>
               `}}>
               </span>
            </>

      }

      return (
         <Widget componentName="cve-detail" caption={cveWidgetCaption} isLoading={this.props.isLoading}>
            {ret}
         </Widget>
      )

   }

}

const mapStateToProps = (state: {
   cves: RCVEListState,
}) => {
   return state;
}


const mapDispatchToProps = (dispatch: Dispatch) => {

   return {
      actions: bindActionCreators(
         Object.assign(
            {},
            slice.actions
         ),
         dispatch
      )
   }

}

export default connect(
   mapStateToProps,
   mapDispatchToProps
)(CVEDetail);
